module.exports = __webpack_public_path__ + "static/img/lunbo7.02b3b07c.webp";